export const MAPTIVE_TUTORIAL_YOUTUBE_ID = 'uAqGpBPws7E';
export const MAPTIVE_OVERVIEW_YOUTUBE_ID = '-oJouK77crY';
